import { useTranslation } from 'react-i18next';

import { EmissionFactorDSSet } from '../../interfaces/IFootprint';

type SecondaryEmissionsFactorSourcesProps = {
  sources: EmissionFactorDSSet[];
};

// Component to display the secondary emissions factor sources, each source is concatenated into one single string, separated by '|'
const SecondaryEmissionsFactorSources = (
  props: SecondaryEmissionsFactorSourcesProps,
): JSX.Element => {
  const { sources } = props;

  const { t } = useTranslation();

  if (!sources.length) {
    return <span className='text-black-alpha-60'>{t('global.notSpecified')}</span>;
  }

  return (
    <span className='flex w-full text-black-alpha-60 break-all'>
      {sources
        .map((src) => {
          return src.secondary_emission_factor_source.replaceAll('|', ':');
        })
        .join(' | ')}
    </span>
  );
};

export default SecondaryEmissionsFactorSources;
